export default "__VITE_ASSET__e3424ca5__"